<template>
  <div class="app-container">
    <div class="user-detail-container">
      <el-card class="user-card">
        <div class="user-header">
          <!-- 只展示头像，不允许上传 -->
          <img
            v-if="userData.avatar"
            :src="userData.avatar"
            class="user-avatar"
          />
          <el-icon v-else class="avatar-uploader-icon">
            <Plus />
          </el-icon>
          <!-- <h3>{{ userData.userName }}</h3> -->
          <!-- <p>
            登录IP：{{ userData.loginIp }} | 登录时间：{{
              formatTime(userData.loginDate)
            }}
          </p> -->
        </div>

        <el-form
          label-width="120px"
          class="user-info-form"
          :model="userData"
          :rules="rules"
          ref="formRef"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="昵称" prop="nickName">
                <el-input
                  v-model="userData.nickName"
                  placeholder="请输入用户名"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="phonenumber">
                <el-input
                  v-model="userData.phonenumber"
                  placeholder="请输入手机号"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="userData.email"
                  placeholder="请输入邮箱"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别">
                <el-select
                  v-model="userData.sex"
                  placeholder="请选择性别"
                  :disabled="!isEditing"
                >
                  <el-option label="男" value="0"></el-option>
                  <el-option label="女" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="form-actions">
            <el-button type="primary" class="save-btn" @click="toggleEdit">
              {{ isEditing ? "保存信息" : "修改信息" }}
            </el-button>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import { useAuthStore } from "@/store/authStore";
import { getUserInfo, updateUserInfo } from "@/api/usercenterApi"; // 导入封装好的方法
import { baseURL } from "@/api/axiosConfig";

const authStore = useAuthStore();
const isEditing = ref(false);

// 表单验证规则
const rules = reactive({
  nickName: [
    { required: true, message: "昵称不能为空", trigger: "blur" },
  ],
  email: [
    {
      validator: (rule, value, callback) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!value) {
          callback(); // 邮箱为空时通过验证
        } else if (!emailRegex.test(value)) {
          callback(new Error("邮箱格式不正确,10位qq号+@qq.com"));
        } else {
          callback();
        }
      },
      trigger: ["blur", "change"],
    },
  ],
  phonenumber: [
    {
      required: true,
      message: "请输入有效的11位手机号",
      trigger: "blur",
    },
    {
      validator: (rule, value, callback) => {
        const phoneRegex = /^1[3-9]\d{9}$/; // 中国大陆手机号格式
        if (!value) {
          callback(new Error("手机号不能为空"));
        } else if (!phoneRegex.test(value)) {
          callback(new Error("手机号格式不正确"));
        } else {
          callback();
        }
      },
      trigger: ["blur", "change"],
    },
  ],
});
// 原始用户数据模板，只包含需要的四个字段
const originalUserData = {
  userName: "",
  phonenumber: "",
  email: "",
  sex: "",
  avatar: "", // 添加头像字段
};

// 响应式用户数据，只包含需要的四个字段
const userData = ref({ ...originalUserData });

// 在获取用户信息后增加 token 校验逻辑
// const isValidToken = (token) => {
//   return typeof token === "string" && token.split(".").length === 3;
// };

// 添加 onMounted 生命周期钩子来获取真实数据
onMounted(async () => {
  console.log("当前 token:", authStore.token);
  // console.log("是否已认证:", authStore.isAuthenticated);
  if (!authStore.isAuthenticated) {
    ElMessage.warning("请先登录");
    return;
  }
  try {
    console.log("传入的 token 值:", authStore.token); // ✅ 正确引用 authStore.token
    const result = await getUserInfo(); // 调用 getUserInfo 方法
    console.log("获取到的用户信息:", result.data);
    if (result.success) {
      // 确保从接口获取所有需要的字段
      userData.value = {
        nickName: result.data.nickName || "",
        phonenumber: result.data.phonenumber || "",
        email: result.data.email || "",
        sex: result.data.sex ? String(result.data.sex) : "0", // 确保性别是字符串0男。1女，2未知
        avatar: baseURL + result.data.avatar || "", // 添加头像
      };
      //authStore.setUser(result.data);
    } else {
      ElMessage.error(result.error || "无法加载用户信息");
    }
  } catch (error) {
    console.error("获取用户信息失败:", error);
    ElMessage.error("用户信息正在建设中");
  }
});
// 格式化时间函数保持不变
// const formatTime = (time) => {
//   if (!time) return "";
//   return time.replace("T", " ").substring(0, 19);
// };
// 头像处理函数
// const handleAvatarSuccess = (res, file) => {
//   userData.value.avatar = URL.createObjectURL(file.raw);
//   ElMessage.success("头像上传成功");
// };
//上传头像时的图片验证
const beforeAvatarUpload = (file) => {
  // 验证逻辑
  const isValidType = ["image/jpeg", "image/png", "image/gif"].includes(
    file.type
  );
  const isValidSize = file.size / 1024 / 1024 < 2;

  if (!isValidType) {
    ElMessage.error("只能上传 JPG/PNG 格式的图片!");
    return false;
  }

  if (!isValidSize) {
    ElMessage.error("图片大小不能超过 2MB!");
    return false;
  }

  return true;
};
//更新用户信息
// const saveUserInfo = async () => {
//   const result = await updateUserInfo(userData.value);
//   if (result.success) {
//     ElMessage.success("用户信息保存成功");
//     console.log("保存的用户信息：", userData.value);
//     authStore.setUser(userData.value);
//   } else {
//     ElMessage.error(result.error || "保存失败，请重试");
//   }
// };
//保存或修改用户信息时的状态
// 切换编辑/保存状态
const formRef = ref();

const toggleEdit = async () => {
  if (!isEditing.value) {
    isEditing.value = true;
  } else {
    if (!formRef.value) {
      ElMessage.error("表单未加载");
      return;
    }

    try {
      // 如果校验失败，就不要继续执行保存
      const valid = await formRef.value.validate().catch((err) => {
        console.error("表单校验失败:", err);
        ElMessage.error("请检查输入内容");
        return false; // 明确返回 false 表示校验失败
      });

      // 校验失败，直接 return
      if (!valid) {
        return;
      }

      // 校验通过，才执行保存
      const result = await updateUserInfo(userData.value);

      if (result?.success) {
        ElMessage.success("用户信息保存成功");
      } else {
        ElMessage.error(result?.error || "保存失败，请重试");
      }
    } catch (error) {
      console.error("保存用户信息异常:", error);
      ElMessage.error("发生未知错误");
    } finally {
      isEditing.value = false;
    }
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    Arial, sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.app-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* .app-header {
  text-align: center;
  margin-bottom: 30px;
  color: #2c3e50;
}

.app-header h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  background: linear-gradient(90deg, #409eff, #67c23a);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.app-header p {
  font-size: 1.1rem;
  color: #5e6d82;
} */

.user-detail-container {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.user-card {
  flex: 1;
  min-width: 450px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 30px;
  transition: all 0.3s ease;
}

.user-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.user-header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.avatar-uploader {
  display: inline-block;
  position: relative;
  margin-bottom: 15px;
}

.user-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e6f7ff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.user-avatar:hover {
  transform: scale(1.05);
  border-color: #409eff;
}

.avatar-uploader-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  font-size: 28px;
  color: #8c939d;
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
}

.avatar-uploader-icon:hover {
  border-color: #409eff;
  color: #409eff;
}

.user-header h3 {
  font-size: 1.8rem;
  margin: 10px 0 5px;
  color: #303133;
}

.user-header p {
  color: #909399;
  font-size: 0.95rem;
}

.user-info-form {
  margin-top: 20px;
}

.el-form-item {
  margin-bottom: 22px;
}

.el-form-item__label {
  font-weight: 600;
  color: #606266;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
}

.save-btn {
  width: 150px;
  height: 45px;
  font-size: 1.1rem;
  background: linear-gradient(90deg, #409eff, #64b3f4);
  border: none;
  transition: all 0.3s;
}

.save-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 7px 15px rgba(64, 158, 255, 0.4);
}

.reset-btn {
  width: 150px;
  height: 45px;
  font-size: 1.1rem;
  transition: all 0.3s;
}

.reset-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 7px 15px rgba(0, 0, 0, 0.1);
}

.info-card {
  flex: 0 0 300px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-title {
  text-align: center;
  font-size: 1.5rem;
  color: #409eff;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #ebeef5;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px dashed #ebeef5;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  flex: 0 0 100px;
  font-weight: 600;
  color: #606266;
}

.info-value {
  flex: 1;
  color: #303133;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.status-active {
  background: #f0f9eb;
  color: #67c23a;
}

.status-inactive {
  background: #fef0f0;
  color: #f56c6c;
}

@media (max-width: 992px) {
  .user-detail-container {
    flex-direction: column;
  }

  .user-card,
  .info-card {
    min-width: 100%;
  }
}

@media (max-width: 576px) {
  .el-col {
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }

  .form-actions {
    flex-direction: column;
    align-items: center;
  }

  .save-btn,
  .reset-btn {
    width: 100%;
  }
}
</style>
